import { useDispatch, useSelector } from "react-redux";
import React, {useEffect} from "react";
import {
	getClientsError,
	getClientsStatus,
	getCustomerClients, getClientsArray
} from "../../redux/CustomerClientsSlice";
import LoadingError from "../Error/LoadingError";
import {useNavigate} from "react-router";
import Box from "@mui/material/Box";
import {DataGridPro, GridToolbar} from "@mui/x-data-grid-pro";
import {NoRowsDialog} from "../Inputs/NoRowsDialog";

function ClientSummaryTable() {
	const dispatch = useDispatch();
	const clients = useSelector(getClientsArray);
	const clientsStatus = useSelector(getClientsStatus);
	const clientsError = useSelector(getClientsError);

	const navigate = useNavigate();

	useEffect(() => {
		if (clientsStatus === 'idle') {
			dispatch(getCustomerClients());
		}
	}, [dispatch, clientsStatus]);
	
	const handleRowClick = (event) => {
		navigate(`/Clients/${event.id}`);
	};

	const columns = [
		{ field: 'name', headerName: 'Name', headerClassName: 'clients-theme--header', cellClassName: 'hyperlink',width: 120 },
		{ field: 'contact1Name', headerName: 'Contact Name', headerClassName: 'clients-theme--header', width: 150 },
		{ field: 'contact1Email', headerName: 'Contact Email', headerClassName: 'clients-theme--header', width: 200 },
		{ field: 'contact1Phone', headerName: 'Contact Phone', headerClassName: 'clients-theme--header', width: 150 },
		{ field: 'createdBy', headerName: 'Created By', headerClassName: 'clients-theme--header', width: 150 },
		{ field: 'createdAt', headerName: 'Created At', headerClassName: 'clients-theme--header', width: 170 }
	];

	return (
		<Box sx={{
			display: 'flex',
			flexDirection: 'column',
			minHeight: '350px',
			maxHeight: '600px',
			"& .MuiDataGrid-row:hover": {
				cursor: "pointer",
			},
			'& .clients-theme--header': {
				color: 'white',
			}
		}}
		>
			<DataGridPro
				checkboxSelection
				disableRowSelectionOnClick
				initialState={{
					density: 'compact',
				}}
				columns={columns}
				onRowClick={handleRowClick}
				rows={clients}
				loading={clientsStatus === 'loading'}
				slots={{
					toolbar: !clientsError && GridToolbar,
                    noRowsOverlay: () => !!clientsError ? <LoadingError component={"clients"} /> : <NoRowsDialog path={"clients"} domain={"Client"} />
				}}
				slotProps={{
					toolbar: {
						showQuickFilter: true,
					},
					loadingOverlay: {
						variant: 'skeleton',
						noRowsVariant: 'skeleton',
					},
				}}
			/>
		</Box>
	)
}

export default ClientSummaryTable;
